import { render, staticRenderFns } from "./ExpenseItems.vue?vue&type=template&id=61870986&"
import script from "./ExpenseItems.vue?vue&type=script&lang=js&"
export * from "./ExpenseItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports